import { z } from "zod/v3";

export const defaultCoverLetterContent = {
  recipient: "",
  company: "",
  jobTitle: "",
  letterBody: "",
};

export const coverLetterContentSchema = z.object({
  recipient: z.string(),
  company: z.string(),
  jobTitle: z.string(),
  letterBody: z.string(),
});
